var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.totalProductQuantity > 0)?_c('div',{staticClass:"rp-button-float",class:{
    'rp-cart-pulse': _vm.cartPulse
  },style:({
    backgroundColor: '#ffffff',
    color: _vm.buttonColor.primary,
    borderColor: _vm.buttonColor.primary,
    fontFamily: _vm.globalFont,
    position: _vm.buttonPosition,
    boxShadow: _vm.buttonColor.shadow
  }),on:{"click":_vm.buyNow,"mousedown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return _vm.dragMouseDown($event)},"touchstart":_vm.touchElement}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"price"},[_vm._v(_vm._s(_vm._f("productPriceFormat")(_vm.totalProductPrice)))]),_vm._v(" "),_c('span',{staticClass:"badge",style:({
      backgroundColor: _vm.buttonColor.primary,
      color: _vm.buttonColor.secondary,
    })},[_vm._v("\n    "+_vm._s(_vm._f("productCountFormat")(_vm.totalProductQuantity))+"\n  ")])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-lg fa-shopping-cart"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24ffa733","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CartButton/ButtonStyle2.vue
// module id = null
// module chunks = 